import React, { useEffect, useState } from "react";
import Others from "./Others";
import { useDispatch } from "react-redux";
import { addToCart } from '../../Components/redux/orebiSlice';
import Modal from "./Modal"; // Import the Modal component
import { parfum1 } from "../../assets/images";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function ProductDetail() {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [selectedQuantity, setSelectedQuantity] = useState(1);  
  const [list, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [clientName, setclientName] = useState("");
  const [clientEmail, setclientEmail] = useState("");
  const [clientPhone, setclientPhone] = useState("");
  const [clientAddress, setclientAddress] = useState("");



  const { id } = useParams();


  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const items = [
    {
      title: 'Başlık 1',
      content: 'Bu, birinci başlığın açıklamasıdır.'
    },
    {
      title: 'Başlık 2',
      content: 'Bu, ikinci başlığın açıklamasıdır.'
    },
    {
      title: 'Başlık 3',
      content: 'Bu, üçüncü başlığın açıklamasıdır.'
    }
  ];
  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.tanura.az/tanura/dashboard.php`,
        { withCredentials: false }
      );
  
        const filteredProducts = response.data.data.filter(product => product.id == id);

        setItems(filteredProducts[0]);
        setIsLoading(false)
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  

  const decreaseQuantity = () => {
    if(selectedQuantity > 1) {
      let quantity2 = selectedQuantity - 1;
      setSelectedQuantity(quantity2);
    } 
  };

  const increaseQuantity = () => {
    let quantity2 = selectedQuantity + 1;
    setSelectedQuantity(quantity2);
  };

    const handleSubmitOrder = async () => {
  

      let inputs = {name:  clientName, email: clientEmail, phone: clientPhone, address: clientAddress, product: list.name}
      try {
        // Seçilen ürünleri post isteği ile gönder
        axios.post("https://www.tanura.az/tanura/orders.php/", inputs)
        .then(function (response) { 
          navigate("/");  
          setclientName('')
          setclientEmail('')
          setclientPhone('')
          setclientAddress('')
  
          // console.log(inputs);
        });
        // Başarılı olduğunda yapılacak işlemler
        toast.success("Sifarişiniz qeydə alındı");
        setIsModalOpen(false);
      } catch (error) {
        // Hata durumunda yapılacak işlemler
        console.error("Sipariş gönderilirken bir hata oluştu:", error);
      }
    };

  return (
   <>
   {console.log(list)}
    <div className="md:max-w-container max-w-containerSm mx-auto mt-[40px] md:mt-[88px]">
      <div className="md:flex">
        <div className="md:w-[411px] md:mr-[44px]">
        <div>
            <div className='bg-[white] mb-3 flex justify-center items-center md:w-[407px] h-[411px] rounded-2xl border border-[#e2e2e2]'>
            <img className='mx-auto w-[270px] h-[270px] md:w-[351px] md:h-[351px]' src={`https://www.tanura.az/tanura/${list.image}`} alt='' />
          </div>
          </div>
        </div> 
        <div className="md:w-[576px]">
          <h4 className="text-[22px] md:text-[28px] mb-2">{list.name}</h4>
          <div className="flex gap-2 mb-8">
          {list.category1 ?   <div className="px-[20px] h-[24px] bg-[#0f1d64] text-white rounded-[20px]">{list.category1}</div> : ""}
          {list.category2 ?   <div className="px-[20px] h-[24px] bg-[#0f1d64] text-white rounded-[20px]">{list.category2}</div> : ""}
          {list.category3 ?   <div className="px-[20px] h-[24px] bg-[#0f1d64] text-white rounded-[20px]">{list.category3}</div> : ""}
          </div>
          <p className="mb-9 text-sm md:text-[16px]">{list.description}</p>
          <div className="mt-10">
      <div className="mb-4 rounded-lg">
        <button
          onClick={() => toggleAccordion(0)}
          className="flex justify-between items-center w-full p-4 text-lg font-medium"
        >
          <span>{t("Məhsul Xüsusiyyətləri")}</span>
          <span className={`transform transition-transform ${openIndex === 0 ? 'rotate-45' : ''}`}>+</span>
        </button>
        {openIndex === 0 && (
          <div className="p-4 text-gray-700 bg-white">
             {list.setting1 ?  <p>{list.setting1}: {list.answer1}</p> : ""}
             {list.setting2 ?  <p>{list.setting2}: {list.answer2}</p> : ""}
             {list.setting3 ?  <p>{list.setting3}: {list.answer3}</p> : ""}
             {list.setting4 ?  <p>{list.setting4}: {list.answer4}</p> : ""}
             {list.setting5 ?  <p>{list.setting5}: {list.answer5}</p> : ""}
          </div>
        )}
      </div>

      <div className="mb-4 rounded-lg">
        <button
          onClick={() => toggleAccordion(1)}
          className="flex justify-between items-center w-full p-4 text-lg font-medium"
        >
          <span>{t("İstifadəsi")}</span>
          <span className={`transform transition-transform ${openIndex === 1 ? 'rotate-45' : ''}`}>+</span>
        </button>
        {openIndex === 1 && (
          <div className="p-4 text-gray-700 bg-white">
             {list.useful}
          </div>
        )}
      </div>

      <div className="mb-4 rounded-lg">
        <button
          onClick={() => toggleAccordion(2)}
          className="flex justify-between items-center w-full p-4 text-lg font-medium"
        >
          <span>{t("Aktiv tərkibi")}</span>
          <span className={`transform transition-transform ${openIndex === 2 ? 'rotate-45' : ''}`}>+</span>
        </button>
        {openIndex === 2 && (
          <div className="p-4 text-gray-700 bg-white">
            {list.composition1 ?  <p>{list.composition1}</p> : ""}
             {list.composition2 ?  <p>{list.composition2}</p> : ""}
             {list.composition3 ?  <p>{list.composition3}</p> : ""}
             {list.composition4 ?  <p>{list.composition4}</p> : ""}
             {list.composition5 ?  <p>{list.composition5}</p> : ""}
             {list.composition6 ?  <p>{list.composition6}</p> : ""}
             {list.composition7 ?  <p>{list.composition7}</p> : ""}
             {list.composition8 ?  <p>{list.composition8}</p> : ""}
             {list.composition9 ?  <p>{list.composition9}</p> : ""}
             {list.composition10 ?  <p>{list.composition10}</p> : ""}
          </div>
        )}
      </div>
    </div>

          <div className="flex mt-6">
            <button 
              onClick={() => setIsModalOpen(true)} // Open modal on button click
              className="mt-4 px-4 py-2 bg-[#223077] rounded-[12px] w-full text-white"
            >
              {t("Sifariş et")}
            </button>
          </div>
        </div>
      </div>
    </div>
    {/* Modal */}
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="flex justify-between items-center mb-4  ">
            <h2 className="text-lg font-medium">{t("Sizin məlumatlarınız")}</h2>
            <button onClick={() => setIsModalOpen(false)} className="text-[black]">
              &#10005;
            </button>
          </div>
          <form onSubmit={handleSubmitOrder}>
            <div className="mb-4">
              <label className="block">{t("Ad, soyad")}*</label>
              <input type="text" className="border rounded-[12px] w-full h-[40px] pl-3 bg-[#F4F4F4] text-black" 
               placeholder={t("Adınızı daxil edin")}
               onChange={(event) => setclientName(event.target.value)}
               value={clientName}
               required
                />
               
            </div>
            <div className="mb-4">
              <label className="block">{t("E-mail")}*</label>
              <input type="email" className="border rounded-[12px] w-full h-[40px] pl-3 bg-[#F4F4F4] text-black"  
              placeholder={t("Emailinizi daxil edin")}
              onChange={(event) => setclientEmail(event.target.value)}
              value={clientEmail}
              required /> 
            </div>
            <div className="mb-4">
              <label className="block">{t("Əlaqə nömrəsi")}*</label>
              <input type="number" className="border rounded-[12px] w-full h-[40px] pl-3 bg-[#F4F4F4] text-black" 
              placeholder={t("Telefon nömrənizi daxil edin")}
              onChange={(event) => setclientPhone(event.target.value)}
              value={clientPhone}
              required /> 
            </div>
            <div className="mb-4">
              <label className="block">{t("Ünvan")}*</label>
              <input type="text" className="border rounded-[12px] w-full h-[40px] pl-3 bg-[#F4F4F4] text-black"  
              placeholder={t("Ünvanınızı daxil edin")}
              onChange={(event) => setclientAddress(event.target.value)}
              value={clientAddress}
              required /> 
            </div>
            <div className="flex justify-center">
              <button  type="submit" className="h-[40px] pl-3 bg-[#223077] text-white rounded-[12px] w-full">{t("Təsdiqlə")}</button>
            </div>
          </form>
      </Modal>  

    <Others />
    </>
  );
}